import { CustomTooltip } from '@/components/custom-tooltip';
import { IconButton } from '@mui/material';
import styles from 'common/_variables.module.scss';
import { MdOutlineGroups } from 'react-icons/md';
import type { View } from './inventory-rate-level-widget/inventory-rate-level-widget';

type GroupIconProps = {
	groupBooked: number;
	groupBlocked: number;
	setView: (view: View) => void;
};

const makeTooltip = (count: number, type: 'booked' | 'blocked') =>
	`${count} group room${count > 1 ? 's' : ''} ${type}`;

export const GroupIcon = ({
	groupBooked,
	groupBlocked,
	setView,
}: GroupIconProps) => {
	if (!groupBooked && !groupBlocked) return null;
	return (
		<CustomTooltip
			content={
				<p>
					{makeTooltip(
						groupBooked || groupBlocked,
						groupBooked ? 'booked' : 'blocked',
					)}
				</p>
			}
		>
			<IconButton
				aria-label='groups'
				className='icon-btn group-icon'
				disableRipple
				onClick={() => setView('inventory')}
				data-testid='groupIcon'
			>
				<MdOutlineGroups
					size={30}
					color={groupBooked ? styles.colorGreen : styles.colorGrey60}
				/>
			</IconButton>
		</CustomTooltip>
	);
};
